module.exports = __webpack_public_path__ + "img/psd.f372d941.svg";